import { ENV } from 'shared/ENV';

export const getWatchdutyStaticTileUrl = (layerName: string): string => {
  return `https://${
    ENV.VITE_STATIC_TILE_CACHE_DOMAIN
  }/maptiles/${layerName}/style.json`;
};
